// @flow
import React from "react";
import AppStoreIcon from "../../static/images/appstore_bt.svg";
import GooglePlayIcon from "../../static/images/googleplay_bt.svg";
import AppStoreIconLight from "../../static/images/appstore_light_bt.svg";
import GooglePlayIconLight from "../../static/images/googleplay_light_bt.svg";

import styles from "./appIcons.module.scss";

type Props = {
  theme?: "light" | "dark"
};

const AppIcons = ({ theme = "dark" }: Props) => {
  const appStore = theme === "dark" ? AppStoreIcon : AppStoreIconLight;
  const googlePlay = theme === "dark" ? GooglePlayIcon : GooglePlayIconLight;

  return (
    <ul className={styles.container}>
      <li className={styles.item}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://justpark.onelink.me/eUfx/448422cd"
        >
          <img
            src={appStore}
            alt="AppStore"
            loading="lazy"
            width="135"
            height="40"
          />
        </a>
      </li>
      <li className={styles.item}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://justpark.onelink.me/n8HU/464fc314"
        >
          <img
            src={googlePlay}
            alt="Google Play"
            loading="lazy"
            width="300"
            height="89"
          />
        </a>
      </li>
    </ul>
  );
};

export default AppIcons;
